<app-common-header></app-common-header>
<main role="main" class="maincnt quest">
  <div class="getbannersect sectppad pb-2 mt-1">
    <div class="sectpad container-fluid">
      <div class="col-sm-12 p-0">
        <div class="col-12 text-center webview">
          <img src="assets/images/signimg.jpg" class="signimg signimgg" />
        </div>
        <div class="col-sm-12 p-0 mt-1 webview preconimgmrgn">
          <h1 class="text-center preconmsg">
            <div [innerHTML]="postResultText"></div>
          </h1>
          <div class="text-center mt-3 mb-4" *ngIf="!postResultResponseFlag">
            <img src="assets/images/loading-old.gif" />
          </div>
          <div class="text-center mt-3 mb-6">
            <div class="clear" style="margin-bottom: 7rem !important"></div>
          </div>
          <p class="text-center precontxt mb-5">
            We noticed a few things you could consider to <br />further reduce
            your energy bill. Would you like to <br />stay connected and hear
            about special offers <br />from our trusted partners?
          </p>
          <div class="col-sm-4 col-md-3 col-xl-2 m-auto text-left">
            <div
              class="form-group custom-control custom-checkbox chkbox mb-2 optnpadd box-shadow"
            >
              <input
                type="checkbox"
                class="form-control custom-control-input mgntp10"
                id="NoThkyou"
                value="No, thank you"
                [(ngModel)]="hgPrecong.value1"
                (click)="getPrecong($event)"
                (change)="nooption()"
              />
              <label class="custom-control-label font16" for="NoThkyou"
                >No, thank you</label
              >
            </div>
            <div
              class="custom-control custom-checkbox chkbox mb-2 optnpadd box-shadow"
            >
              <input
                type="checkbox"
                class="custom-control-input mgntp10"
                id="YesInterest"
                value="Yes, I'm interested!"
                [(ngModel)]="hgPrecong.value2"
                (click)="getPrecong($event)"
                (change)="nooption()"
              />
              <label class="custom-control-label font16" for="YesInterest"
                >Yes, I'm interested!</label
              >
            </div>
            <div class="col-12 p-0 mt-4 text-center">
              <button
                style="width: 150px !important"
                class="btn next disabledButton col-md-12 col-lg-12 m-auto font22 text-uppercase"
                [disabled]="disableBtn"
                [ngClass]="{ sectbtn: ngClass }"
                (click)="next()"
              >
                Next
              </button>
            </div>
          </div>
        </div>
        <div class="container mobileview mt-0 pt-2">
          <div class="row d-flex h-100 mt-3">
            <div class="col-12 d-flex">
              <div
                class="justify-content-center align-self-center col-sm-3 col-3 px-0"
              >
                <img
                  style="width: 100% !important"
                  src="assets/images/signimg.jpg"
                />
              </div>
              <div class="col-sm-9 col-9 px-0 my-auto">
                <div class="arrow_box">
                  <h1
                    class="questionMob text-left"
                    *ngIf="!postResultResponseFlag"
                  >
                    While you wait for us to process your enrollment...
                  </h1>
                  <h1
                    class="questionMob text-left"
                    *ngIf="postResultResponseFlag"
                  >
                    Your enrollment has been processed Press NEXT to proceed.
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mt-3 mb-4">
            <img src="assets/images/loading-old.gif" />
          </div>
          <!-- <div class="d-flex h-100 row col-sm-12 pr-0 mt-5">
            <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
              <img style="width:100% !important;" src="assets/images/signimg.jpg" />
            </div>
            <div class="col-sm-9 col-9 px-0 my-auto">
              <div class="arrow_box">
                <h1 class="questionMob text-left mbheadfnt">We noticed a few things you could consider to further reduce your
                  energy bill.
                  <br>Would you like to stay connected and hear about special offers from our trusted partners?</h1>
              </div>
            </div>
          </div> -->
          <div class="chat-bx col-sm-9 col-8 px-0 m-auto">
            <div class="mb-3">
              <h1
                class="text-left col-sm-12 p-0 mbheadfnt font-weight-normal-calibre clrblk"
              >
                We noticed a few things you could consider to further reduce
                your energy bill. Would you like to stay connected and hear
                about special offers from our trusted partners?
              </h1>
            </div>
            <div class="col-12 col-sm-12 px-0">
              <div class="col-12 px-0">
                <div
                  class="custom-control custom-checkbox chkbox mb-2"
                  id="mbNo"
                >
                  <input
                    type="checkbox"
                    value="No, thank you"
                    class="custom-control-input"
                    id="NoThkyou_mob"
                    [(ngModel)]="hgPrecong.value1"
                    (click)="getPrecong($event)"
                    (change)="nooption1()"
                  />
                  <label
                    class="custom-control-label optnpadd"
                    for="NoThkyou_mob"
                    >No, thank you</label
                  >
                </div>
              </div>
              <div class="col-12 px-0">
                <div
                  class="custom-control custom-checkbox chkbox mb-2"
                  id="mbyes"
                >
                  <input
                    type="checkbox"
                    value="Yes, I'm interested!"
                    class="custom-control-input"
                    id="YesInterest_mob"
                    [(ngModel)]="hgPrecong.value2"
                    (click)="getPrecong($event)"
                    (change)="nooption1()"
                  />
                  <label
                    class="custom-control-label optnpadd"
                    for="YesInterest_mob"
                    >Yes, I'm interested!</label
                  >
                </div>
              </div>
              <!-- <div style="width:100% !important; text-align: right;">
              <div *ngIf="user_bot" class=" mt-2 ash_box text-right">
                <h1 class="ansMob text-right">{{ans_in_precong}}</h1>
              </div>
            </div> -->
              <div class="mt-3">
                <div class="col-12 px-0 m-auto text-center">
                  <button
                    class="btn disabledButton col-md-12 col-lg-12 m-auto font22 text-uppercase"
                    [disabled]="disableBtn"
                    [ngClass]="{ sectbtn: ngClass, pt4: !ngClass }"
                    (click)="next()"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
            <!-- <div class="mt-4">
          <div class="col-6 p-0 m-auto text-center">
              <button class="btn sectbtn col-md-12 col-lg-12 m-auto font22 text-uppercase" [disabled]="disableBtn"
                (click)="next()">Next</button>
            </div>
          </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
